/**
 * Microphone samples → a small 16 kHz mono 16-bit WAV, base64. coπ sends it
 * to Gemini, which takes WAV but not the WebM Chrome records. 16 kHz is plenty
 * for speech: ~32 KB per second.
 */

export function encodeWav16k(chunks: Float32Array[], rate: number): string {
  const total = chunks.reduce((n, c) => n + c.length, 0);
  const input = new Float32Array(total);
  let o = 0;
  for (const c of chunks) { input.set(c, o); o += c.length; }

  // Downsample by averaging each output sample's window (a cheap low-pass).
  const target = 16000;
  const ratio = rate / target;
  const n = Math.max(0, Math.floor(total / ratio));
  const pcm = new Int16Array(n);
  for (let i = 0; i < n; i++) {
    const from = Math.floor(i * ratio), to = Math.min(total, Math.floor((i + 1) * ratio));
    let sum = 0;
    for (let j = from; j < to; j++) sum += input[j];
    const v = to > from ? sum / (to - from) : 0;
    pcm[i] = Math.max(-1, Math.min(1, v)) * 0x7fff;
  }

  const bytes = new Uint8Array(44 + pcm.length * 2);
  const view = new DataView(bytes.buffer);
  const str = (at: number, s: string) => { for (let i = 0; i < s.length; i++) bytes[at + i] = s.charCodeAt(i); };
  str(0, 'RIFF'); view.setUint32(4, 36 + pcm.length * 2, true); str(8, 'WAVE');
  str(12, 'fmt '); view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
  view.setUint32(24, target, true); view.setUint32(28, target * 2, true); view.setUint16(32, 2, true); view.setUint16(34, 16, true);
  str(36, 'data'); view.setUint32(40, pcm.length * 2, true);
  new Int16Array(bytes.buffer, 44).set(pcm);

  let bin = '';
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(bin);
}
